export class StringConst {
    static REG_KATAKANA = '^[ァ-ー]+$';
    static REG_MAIL = '^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$';
    static REG_PHONE_NUMBER = '^0[5789]0([0-9]{4})([0-9]{4})$';
}

